const PATHFINDING_OPTIONS = [
  { value: 'bfs', label: 'BFS' },
  { value: 'dfs', label: 'DFS' },
  { value: 'dijkstra', label: 'Dijkstra' },
  { value: 'astar', label: 'A*' }
]

export default PATHFINDING_OPTIONS
